import { http, HttpResponse } from "msw";

import { ListUserOrgsResponse } from "@protos/auth/v1/user";
import { Deployment, OrgRole } from "@protos/deployment/v1/deployment";

export const TEST_DEPLOYMENT: Deployment = {
  id: 1,
  name: "TestOrg",
  displayName: "TestOrg",
  slug: "testorg",
  sourceType: "github",
  organizationId: 1,
  features: {
    hasAutofix: false,
    hasDeepsemgrep: false,
    hasTriageViaComment: false,
    hasDependencyQuery: false,
    defaultUserRole: OrgRole.ADMIN,
    editorSemgrepVersion: "1.0.0",
    featureFlags: [],
  },
};

const USER_ORGS: ListUserOrgsResponse = {
  userId: 1,
  orgs: [TEST_DEPLOYMENT],
};

export const userOrgsHandlersStatic = [
  http.get("*/api/auth/users/:id/deployments", () =>
    HttpResponse.json(USER_ORGS, { status: 200 })
  ),
];
